import React from 'react';
import { FormLogin } from './FormLogin';

import { Layout } from '../../components/common/Layout';

export const LoginPage = props => {

    return (
        <Layout>
            <FormLogin />
        </Layout>
    )
}
